import {
  Button,
  Heading,
  Link,
  Paragraph,
  RefreshCwIcon,
} from '@buffer-mono/popcorn'

import styles from './ErrorBoundary.module.css'

import type { JSX } from 'react'

const handleRefresh = (): void => {
  location.reload()
}

const openBrainFishWidget = (): void => {
  if (window.Brainfish?.Widgets?.open) {
    window.Brainfish.Widgets.open()
  } else {
    window.open('https://support.buffer.com/?openContact=true', '_blank')
  }
}

const BoundaryFallback = (): JSX.Element => {
  return (
    <div className={styles.errorBoundary}>
      <Heading as="h2" size="large">
        Well this is embarrassing...
      </Heading>

      <Paragraph
        size="lg"
        align="center"
        className={styles.errorBoundaryMessage}
      >
        Sorry. It looks like something unexpected happened. Please{' '}
        <Link as="button" onClick={openBrainFishWidget}>
          click here
        </Link>{' '}
        to report this to our team so we can get this fixed up.
      </Paragraph>
      <Button variant="secondary" onClick={handleRefresh}>
        <RefreshCwIcon />
        Refresh
      </Button>
    </div>
  )
}

export default BoundaryFallback
